import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "absolute -top-1 -right-1 inline-flex items-center justify-center w-5 h-5 text-[10px] font-bold text-white bg-red-500 rounded-full"
}
const _hoisted_2 = {
  class: "relative w-64 h-full bg-white border-l border-gray-200 shadow-lg flex flex-col",
  style: {"margin-top":"0"}
}
const _hoisted_3 = { class: "flex items-center gap-2 px-3 py-3 border-b border-gray-200 shrink-0" }
const _hoisted_4 = { class: "inline-flex items-center justify-center w-7 h-7 rounded-full bg-blue-100 text-xs font-medium text-blue-800 shrink-0" }
const _hoisted_5 = { class: "text-sm font-semibold text-gray-900 truncate" }
const _hoisted_6 = {
  ref: "messagesContainer",
  class: "flex-1 overflow-y-auto px-3 py-3 space-y-2"
}
const _hoisted_7 = {
  key: 0,
  class: "flex justify-center py-4"
}
const _hoisted_8 = {
  key: 0,
  class: "text-center text-gray-400 text-xs py-4"
}
const _hoisted_9 = { class: "text-sm whitespace-pre-line break-words" }
const _hoisted_10 = { class: "px-3 py-2 border-t border-gray-200 shrink-0" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "flex-1 overflow-y-auto" }
const _hoisted_14 = { class: "px-4 pt-4 pb-2" }
const _hoisted_15 = { class: "text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" }
const _hoisted_16 = {
  key: 0,
  class: "text-xs text-gray-400 py-1"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "inline-flex items-center justify-center w-7 h-7 rounded-full bg-blue-100 text-xs font-medium text-blue-800 shrink-0" }
const _hoisted_19 = { class: "text-sm text-gray-700 truncate" }
const _hoisted_20 = { class: "px-4 pt-2 pb-4" }
const _hoisted_21 = { class: "text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" }
const _hoisted_22 = {
  key: 0,
  class: "text-xs text-gray-400 py-1"
}
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "inline-flex items-center justify-center w-7 h-7 rounded-full bg-blue-100 text-xs font-medium text-blue-800 shrink-0" }
const _hoisted_25 = { class: "flex-1 min-w-0" }
const _hoisted_26 = { class: "flex items-center justify-between" }
const _hoisted_27 = { class: "text-sm font-medium text-gray-900 truncate" }
const _hoisted_28 = { class: "inline-flex items-center justify-center w-5 h-5 text-[10px] font-bold text-white bg-red-500 rounded-full shrink-0 ml-1" }
const _hoisted_29 = { class: "text-xs text-gray-400 truncate" }
const _hoisted_30 = { class: "px-4 pt-2 pb-4" }
const _hoisted_31 = { class: "text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "inline-flex items-center justify-center w-7 h-7 rounded-full bg-gray-100 text-xs font-medium text-gray-600 shrink-0" }
const _hoisted_34 = { class: "flex-1 min-w-0" }
const _hoisted_35 = { class: "text-sm text-gray-700 truncate block" }
const _hoisted_36 = {
  key: 0,
  class: "text-xs text-gray-400 truncate"
}
const _hoisted_37 = {
  key: 0,
  class: "text-gray-300"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" Mobile toggle button "),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = $event => ($setup.open = !$setup.open)),
      class: "md:hidden fixed bottom-4 right-4 z-50 w-12 h-12 bg-blue-700 text-white rounded-full shadow-lg flex items-center justify-center hover:bg-blue-800 transition"
    }, [
      _cache[5] || (_cache[5] = _createElementVNode("svg", {
        class: "w-5 h-5",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [
        _createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"
        })
      ], -1 /* CACHED */)),
      ($setup.totalUnread > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString($setup.totalUnread > 9 ? '9+' : $setup.totalUnread), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    _createCommentVNode(" Sidebar panel "),
    _createElementVNode("div", {
      class: _normalizeClass(['fixed top-0 right-0 h-full z-40 transition-transform duration-300',
                $setup.open ? 'translate-x-0' : 'translate-x-full md:translate-x-0'])
    }, [
      _createCommentVNode(" Backdrop (mobile) "),
      ($setup.open)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 bg-black/30 md:hidden",
            onClick: _cache[1] || (_cache[1] = $event => ($setup.open = false))
          }))
        : _createCommentVNode("v-if", true),
      _createElementVNode("aside", _hoisted_2, [
        _createCommentVNode(" Close button (mobile) "),
        _createElementVNode("button", {
          onClick: _cache[2] || (_cache[2] = $event => ($setup.open = false)),
          class: "md:hidden absolute top-3 right-3 text-gray-400 hover:text-gray-600 text-xl z-10"
        }, "×"),
        _createCommentVNode(" CHAT VIEW "),
        ($setup.chatUser)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createCommentVNode(" Chat header "),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                  onClick: _cache[3] || (_cache[3] = $event => ($setup.chatUser = null)),
                  class: "text-gray-400 hover:text-gray-600"
                }, [...(_cache[6] || (_cache[6] = [
                  _createElementVNode("svg", {
                    class: "w-4 h-4",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M15 19l-7-7 7-7"
                    })
                  ], -1 /* CACHED */)
                ]))]),
                _createElementVNode("span", _hoisted_4, _toDisplayString($setup.chatUser.name?.charAt(0)?.toUpperCase() || '?'), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_5, _toDisplayString($setup.chatUser.name), 1 /* TEXT */)
              ]),
              _createCommentVNode(" Chat messages "),
              _createElementVNode("div", _hoisted_6, [
                ($setup.chatLoading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("div", { class: "w-5 h-5 border-2 border-blue-300 border-t-blue-600 rounded-full animate-spin" }, null, -1 /* CACHED */)
                    ]))]))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      ($setup.chatMessages.length === 0)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString($setup.t('sidebar.no_messages_yet')), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.chatMessages, (msg) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: msg.id,
                          class: _normalizeClass(['flex', msg.user.id === $props.userId ? 'justify-end' : 'justify-start'])
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(['max-w-[85%] rounded-xl px-3 py-1.5',
                            msg.user.id === $props.userId ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-900'])
                          }, [
                            _createElementVNode("p", _hoisted_9, _toDisplayString(msg.body), 1 /* TEXT */),
                            _createElementVNode("p", {
                              class: _normalizeClass(['text-[10px] mt-0.5', msg.user.id === $props.userId ? 'text-blue-200' : 'text-gray-400'])
                            }, _toDisplayString($setup.formatTime(msg.created_at)), 3 /* TEXT, CLASS */)
                          ], 2 /* CLASS */)
                        ], 2 /* CLASS */))
                      }), 128 /* KEYED_FRAGMENT */))
                    ], 64 /* STABLE_FRAGMENT */))
              ], 512 /* NEED_PATCH */),
              _createCommentVNode(" Chat input "),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("form", {
                  onSubmit: _withModifiers($setup.sendMessage, ["prevent"]),
                  class: "flex gap-1.5"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    ref: "chatInput",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($setup.newMessage) = $event)),
                    type: "text",
                    placeholder: $setup.t('sidebar.type_message'),
                    required: "",
                    class: "flex-1 px-2.5 py-1.5 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                  }, null, 8 /* PROPS */, _hoisted_11), [
                    [_vModelText, $setup.newMessage]
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    disabled: !$setup.newMessage.trim(),
                    class: "px-2.5 py-1.5 text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 transition disabled:opacity-50 shrink-0"
                  }, [...(_cache[8] || (_cache[8] = [
                    _createElementVNode("svg", {
                      class: "w-4 h-4",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24"
                    }, [
                      _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
                      })
                    ], -1 /* CACHED */)
                  ]))], 8 /* PROPS */, _hoisted_12)
                ], 32 /* NEED_HYDRATION */)
              ])
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createCommentVNode(" USER LIST VIEW "),
              _createElementVNode("div", _hoisted_13, [
                _createCommentVNode(" Online Users "),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("h3", _hoisted_15, [
                    _createTextVNode(_toDisplayString($setup.t('sidebar.online')) + " ", 1 /* TEXT */),
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-green-500 ml-1" }, "●", -1 /* CACHED */))
                  ]),
                  ($setup.onlineUsers.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString($setup.t('sidebar.no_online')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.onlineUsers, (user) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: 'online-' + user.id,
                      onClick: $event => ($setup.openChat(user)),
                      class: "w-full flex items-center gap-2 px-2 py-1.5 rounded-lg hover:bg-gray-50 transition text-left"
                    }, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(user.name?.charAt(0)?.toUpperCase() || '?'), 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_19, _toDisplayString(user.name), 1 /* TEXT */),
                      _cache[10] || (_cache[10] = _createElementVNode("span", { class: "w-2 h-2 rounded-full bg-green-500 shrink-0 ml-auto" }, null, -1 /* CACHED */))
                    ], 8 /* PROPS */, _hoisted_17))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("hr", { class: "border-gray-100 mx-4" }, null, -1 /* CACHED */)),
                _createCommentVNode(" Unread Messages "),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("h3", _hoisted_21, _toDisplayString($setup.t('sidebar.unread')), 1 /* TEXT */),
                  ($setup.unreadConversations.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString($setup.t('sidebar.no_unread')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.unreadConversations, (conv) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: 'unread-' + conv.id,
                      onClick: $event => ($setup.openChat(conv.other_user)),
                      class: "w-full flex items-center gap-2 px-2 py-1.5 rounded-lg hover:bg-gray-50 transition text-left"
                    }, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(conv.other_user?.name?.charAt(0)?.toUpperCase() || '?'), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("span", _hoisted_27, _toDisplayString(conv.other_user?.name), 1 /* TEXT */),
                          _createElementVNode("span", _hoisted_28, _toDisplayString(conv.unread_count), 1 /* TEXT */)
                        ]),
                        _createElementVNode("p", _hoisted_29, _toDisplayString(conv.last_message), 1 /* TEXT */)
                      ])
                    ], 8 /* PROPS */, _hoisted_23))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                ($setup.recentConversations.length > 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[12] || (_cache[12] = _createElementVNode("hr", { class: "border-gray-100 mx-4" }, null, -1 /* CACHED */)),
                      _createCommentVNode(" Recent Conversations (offline users) "),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("h3", _hoisted_31, _toDisplayString($setup.t('sidebar.recent')), 1 /* TEXT */),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.recentConversations, (conv) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: 'recent-' + conv.id,
                            onClick: $event => ($setup.openChat(conv.other_user)),
                            class: "w-full flex items-center gap-2 px-2 py-1.5 rounded-lg hover:bg-gray-50 transition text-left"
                          }, [
                            _createElementVNode("span", _hoisted_33, _toDisplayString(conv.other_user?.name?.charAt(0)?.toUpperCase() || '?'), 1 /* TEXT */),
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("span", _hoisted_35, _toDisplayString(conv.other_user?.name), 1 /* TEXT */),
                              (conv.last_message)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_36, [
                                    (conv.last_message.user_id === $props.userId)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString($setup.t('sidebar.you')) + ": ", 1 /* TEXT */))
                                      : _createCommentVNode("v-if", true),
                                    _createTextVNode(" " + _toDisplayString(conv.last_message.body), 1 /* TEXT */)
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ]),
                            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "w-2 h-2 rounded-full bg-gray-300 shrink-0 ml-auto" }, null, -1 /* CACHED */))
                          ], 8 /* PROPS */, _hoisted_32))
                        }), 128 /* KEYED_FRAGMENT */))
                      ])
                    ], 64 /* STABLE_FRAGMENT */))
                  : _createCommentVNode("v-if", true)
              ])
            ], 64 /* STABLE_FRAGMENT */))
      ])
    ], 2 /* CLASS */)
  ], 64 /* STABLE_FRAGMENT */))
}